import initialState from './AppointmentInitialState';
import * as type from './AppointmentType';

export const appointmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_APPOINTMENTS.SUCCESS:
            return { ...state, appointments: action.payload };
        case type.REPLACE_EDITED_PATIENT: {
            const found = state.appointments?.filter((val) => val.patient.id === action.payload.id);
            if (found && found.length) {
                let newAppointments = [...state?.appointments];
                found.forEach((val) => {
                    const index = newAppointments.findIndex((appoint) => appoint.id === val.id);
                    newAppointments.splice(index, 1, {
                        ...val,
                        patient: action.payload
                    });
                });
                return { ...state, appointments: newAppointments, forceReload: true };
            } else {
                return state;
            }
        }
        case type.ADD_APPOINTMENT: {
            const result = state.appointments?.findIndex((val) => val.id === action.payload.id);
            if (result !== -1) {
                return state;
            } else {
                return { ...state, appointments: [...state?.appointments, action.payload] };
            }
        }
        case type.CHANGE_APPOINTMENT_SIGNAL: {
            const result = state.appointments?.findIndex((val) => val.id === action.payload.id);
            if (result !== -1) {
                return {
                    ...state,
                    appointments: state.appointments?.map((i) => {
                        if (i.id === action.payload.id) {
                            return {
                                ...i,
                                ...action.payload
                            };
                        }
                        return i;
                    })
                };
            } else {
                return {
                    ...state,
                    appointments: [...state?.appointments, action.payload]
                };
            }
        }
        case type.DELETE_APPOINTMENT_SIGNAL:
            return {
                ...state,
                appointments: state.appointments?.filter((val) => val.id !== action.payload)
            };
        case type.TOGGLE_FORCE_RELOAD:
            return { ...state, forceReload: action.payload };
        case type.SET_HOUR:
            return { ...state, date: { ...state.date, hour: action.payload } };
        case type.SET_DATE:
            return { ...state, date: { ...state.date, selected: action.payload } };
        case type.SET_WEEK:
            return { ...state, date: { ...state.date, week: action.payload } };
        case type.SET_SELECTED_APPOINTMENT:
            return { ...state, selectedAppointment: action.payload };
        case type.SET_EDITED_APPOINTMENT:
            return { ...state, editedAppointment: action.payload };
        case type.GET_PATIENT_APPOINTMENTS.SUCCESS:
            return { ...state, appointment: action.payload };
        case type.ADD_PATIENT_APPOINTMENT: {
            const result = state.appointment?.findIndex((val) => val.id === action.payload.id);
            if (result !== -1) {
                return state;
            } else {
                return {
                    ...state,
                    appointment: [action.payload, ...state?.appointment]
                };
            }
        }
        case type.REMOVE_PATIENT_APPOINTMENT:
            return {
                ...state,
                appointment: state?.appointment.filter((val) => val.id !== action.payload)
            };
        case type.EDIT_PATIENT_APPOINTMENT:
        case type.CHANGE_APPOINTMENT_STATUS: {
            let newAppointments = [...state?.appointment];
            const index = newAppointments.findIndex((appoint) => appoint.id === action.payload?.id);
            if (index >= 0) {
                newAppointments.splice(index, 1, action.payload);
            }
            return {
                ...state,
                appointment: newAppointments
            };
        }
        case type.SET_SELECTED_ADMISSION.SUCCESS: {
            return {
                ...state,
                selectedAdmission: action.payload
            };
        }
        default:
            return state;
    }
};
